export const env = (key: string) => {
  const value = process.env['REACT_APP_' + process.env.REACT_APP_ENV.toUpperCase() + '_' + key]
  return value ? value : ''
}
